import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>; // Prevent redirect before auth check

  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
